import React, {useEffect, useState} from 'react'
import {useInputCheck} from '../../../../utils/etc'
import WizPagination from '../../../../components/pagination/WizPagination'
import AnnounceListTable from './AnnounceListTable'
import AnnounceSearchContainer from './AnnounceSearchContainer'
import useQueryAnnounceList from '../../../../hooks/api/announce/useQueryAnnounceList'

interface IProps {
    className?: string
}

const AnnounceListContainer: React.FC<IProps> = ({className}) => {
    const {checkList, onCheckedFunction, resetCheckList, onChangeCheckList} = useInputCheck()

    const [currentPage, setCurrentPage] = useState(1)
    const {data, refetch} = useQueryAnnounceList(currentPage)

    useEffect(() => {
        const currentPageParams = new URLSearchParams(window.location.search).get('page')
        setCurrentPage(Number(currentPageParams) || 1)
    }, [])

    useEffect(() => {
        resetCheckList()
        refetch()
    }, [currentPage])
    return (
        <>
            <AnnounceSearchContainer checkList={checkList} />
            <AnnounceListTable
                data={data?.data}
                checkList={checkList}
                className={'mt-[30px]'}
                onChecked={e => onCheckedFunction(e)}
            />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => {
                    setCurrentPage(item)
                    window.history.pushState('', '', `?page=${item}`)
                }}
            />
        </>
    )
}
export default AnnounceListContainer
